__turbopack_context__.v({
  "rotate": "Spinner-module-scss-module__RBuESq__rotate",
  "spinner": "Spinner-module-scss-module__RBuESq__spinner",
  "wrapper": "Spinner-module-scss-module__RBuESq__wrapper",
});
